import React, {useState, useEffect} from 'react';
import { 
    Grid,
    FormControl,
    TextField,
    Container,
    Typography
} from "@mui/material";
import { useStateValue } from "../../../../../context/store";
import {styles} from './styles'
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const Index = (props) => {
    const classes = styles();
    const [characters, updateCharacters] = useState(props?.valuesOptions);
    const [validate, setValidate] = useState(false)
    const [{valorationQuestionnaire, valorateAplication, disabledQuestionary, dataAplication }, dispatch ] = useStateValue();
    const [valueQuestion, setValueQuestion] = useState()

   
    function handleOnDragEnd(result) {

        if (!result.destination) return;
        const items = Array.from(characters);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        updateCharacters(items);
      }

      const schema = yup.object().shape({
     
        valueTotalQuestion: dataAplication?.data?.associatedQuestions?.length === 1 ? 
        yup
        .string()
        .required('Requerido')
        .matches(
          /^[0-9]{1,3}(\.[0-9]{0,2})?$/g,
          "Ejm: 10.30"
        )
        .test("maxLenght", "Ingrese un valor entre 1 y 100", val => val <= 100 && val >= 1)
      : 
        yup
        .string()
        .required('Requerido')
        .matches(
          /^[0-9]{1,2}(\.[0-9]{0,2})?$/g,
          "Ejm: 10.30"
        )
    })

      const { register, handleSubmit, control, trigger, unregister, clearErrors, formState:{errors}, setValue, watch } = useForm({
        resolver: yupResolver(schema),
        mode: "onTouched",
        reValidateMode: "onChange",
      });

      const handleOnchange = (e)=> {
        const {name, value} = e.target;
       
        setValue(name, value)
        setValueQuestion(value)
        trigger(name)
  
        const filterUuid = valorateAplication?.data.filter((x)=> x?.uuid !== `${props?.uuid}`)
        const newAnswers = []
          for (let index = 0; index < characters.length; index++) {
                newAnswers.push({uuid: characters[index]?.uuid, valueApplied: Number(value)})
            }
           
        
            filterUuid.push({uuid: `${props?.uuid}` , questionAlternativeList: newAnswers, valueApplied: Number(value) })
           
            dispatch({
              type: "SET_MODAL_VALORATE_APLICATION",
              icon:'WARNING',
              data: filterUuid
            })
      }

      useEffect(()=> {
        setValue('valueTotalQuestion', Number((valorationQuestionnaire?.totalValueQuestionnaire)) ? Number((valorationQuestionnaire?.totalValueQuestionnaire)).toFixed(2) : '')
        setValueQuestion(Number((valorationQuestionnaire?.totalValueQuestionnaire)) ? Number((valorationQuestionnaire?.totalValueQuestionnaire)).toFixed(2) : '')
        if(valorationQuestionnaire?.typeValoration === 'automatic'){
        dispatch({
          type: "SET_VALUE_QUESTIONNAIRE",
          totalValueQuestionnaire: valorationQuestionnaire?.totalValueQuestionnaire,
          typeValoration: 'automatic',
          activeValoration: false
        });
        const filterUuid = valorateAplication?.data.filter((x)=> x?.uuid !== `${props?.uuid}`)
       
        const newAnswers = []
          for (let index = 0; index < characters.length; index++) {
                newAnswers.push({uuid: characters[index]?.uuid, valueApplied: valorationQuestionnaire?.totalValueQuestionnaire})
            }
           
            filterUuid.push({uuid: `${props?.uuid}` , questionAlternativeList: newAnswers, valueApplied: valorationQuestionnaire?.totalValueQuestionnaire })
           
            dispatch({
              type: "SET_MODAL_VALORATE_APLICATION",
              icon:'WARNING',
              data: filterUuid
            })
        }else {
          dispatch({
            type: "SET_VALUE_QUESTIONNAIRE",
            totalValueQuestionnaire: valorationQuestionnaire?.totalValueQuestionnaire,
            typeValoration: 'manual',
            activeValoration: false
          });
        }
      
      },[valorationQuestionnaire?.activeValoration ])

      const onSubmit= () => {
        dispatch({
              type: "SET_MODAL_VALORATE_APLICATION",
              activeValorate: true,
              dataClear: valorateAplication?.data ?  valorateAplication?.data :[],
              data: valorateAplication?.data ?  valorateAplication?.data :[]
            })
      }



    return  <form id="formAplication" onSubmit={handleSubmit(onSubmit)}>
    <Grid container spacing={1}  justifyContent="center" alignItems="center" style={{ flexDirection: 'column', alignItems: 'inherit', }} >
    <Grid item lg={12} style={{display: 'flex'}}>
        <Grid item lg={10} >
            <FormControl variant='outlined' fullWidth size="small">
                <TextField
                disabled={true}
                className={classes.dropdown}
                fullWidth
                multiline
                maxRows={65}
                value={props?.question}
                size="small"
                />
            </FormControl>
        </Grid>
        <Grid item lg={1} style={{display: 'flex', marginLeft: '3%'}}>
            <FormControl variant='outlined' fullWidth size="small">
                <TextField
                {...register('valueTotalQuestion')}
                className={classes.dropdown}
                fullWidth
                placeholder='Valor'
                size="small"
                onChange={(e)=>handleOnchange(e)}
                error={!!errors.hasOwnProperty("valueTotalQuestion") && errors["valueTotalQuestion"].message}
                disabled={valorationQuestionnaire?.totalValueQuestionnaire || props?.isDetail || !valorationQuestionnaire?.typeValoration || disabledQuestionary?.disabled}
                value={props?.isDetail ? props?.valueQuestion : valueQuestion}
            />
            </FormControl>
        </Grid> 
    </Grid>
       <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="characters" >
            {(provided) => (
              <ul className="characters" {...provided.droppableProps} ref={provided.innerRef} style={{flex: 'auto', width: 'inherit' }}>
                {characters.map(({key, value}, index, idRank) => {
                  
                  return (
                    <Draggable key={key} draggableId={ props?.isDetail ? 0 : key } index={index} >
                      {(provided) => (
                      <div style={{marginLeft: index+1 === 10 ? -15 :-5, display: 'flex', alignItems: 'baseline'}}>
                            <p style={{color: '#bdbdbd'}}>{index+1}</p>
                         <Container ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <Grid item lg={5} style={{display: 'flex', marginBottom: '2%', border: '1px solid #bdbdbd', background: '#ffffff', borderRadius: 10}} >
                              <FormControl variant='outlined' fullWidth size="small">
                              <Typography  style={{padding: '10px 50px', color: '#c5bfbf'}}>{key}</Typography >
                              </FormControl>
                          </Grid> 
                        </Container>
                       
                       </div >
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
     </Grid>
     </form>
};

export default Index;
